import {Component, OnInit} from '@angular/core';
import {ModalDismissReasons, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {routerTransition} from '@app/router.animations';
import {ToastrService} from 'ngx-toastr';
import {LoaderService} from '@app/shared/services';
import {ReportService} from '@app/shared/services/report.service';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-warehouse-report',
  templateUrl: './warehouse-report.component.html',
  styleUrls: ['./warehouse-report.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    RouterLink,
  ],
  animations: [routerTransition()]
})
export class WarehouseReportComponent implements OnInit {

  user_rights: any;
  user_data: any;

  stock_data: any;
  warehouse_data: any;
  warehouse_warehouse: any;
  medicine: any;
  warehouse_name: any;
  search_text: any;
  total_amount = 0;
  p = 10;
  public collection: any = '';
  page = 1;

  start = 0;
  limit = 10;
  index: any;
  closeResult = '';
  warehouse: any;
  purchase_data: any;
  data: any;
  public total_available_qty = 0;
  public total_move_qty = 0;
  medicine_id = 0;
  warehouse_move_data: any = {
    purchase_id: [],
    old_warehouses_id: [],
    check: [],
    user_id: '',
    medicine_id: '',
    qty: [],
    ware_stock_detailed_id: [],
    purchase_detailed_id: [],
    move_qty: [],
    move_warehouse_id: 0
  };
  private modalRef?: NgbModalRef;

  constructor(private route: ActivatedRoute, private loaderService: LoaderService, private modalService: NgbModal, public reportService: ReportService, private toastr: ToastrService,) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.medicine_id = +(this.route.snapshot.paramMap.get('id') || "")
    this.listWarehouseReport();
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.listWarehouseReport();
    }
  }

  public changeCheckbox(i: any) {

    if (this.purchase_data[i].check == 0) {
      this.purchase_data[i].check = 1;
      this.warehouse_move_data.check[i] = 1;
    } else {
      this.purchase_data[i].check = 0;
      this.warehouse_move_data.check[i] = 0;
    }

  }

  public checkquantity() {
    let total = 0;
    this.warehouse_move_data.ware_stock_detailed_id.forEach((item: any, index: any) => {
      if (this.warehouse_move_data.check[index] == 1) {
        total = total + parseInt(this.warehouse_move_data.move_qty[index]);
        if (parseInt(this.warehouse_move_data.qty[index]) < parseInt(this.warehouse_move_data.move_qty[index])) {
          this.toastr.warning(' Move quantity should be less than or equal to available quantity');
        }
      }
    });
    this.total_move_qty = total;
  }

  public listWarehouse(warehouse: any) {

    const postData = {
      warehouse_id: warehouse
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.listWarehouse(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.warehouse_warehouse = result['data'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public savemoveWarehouse(): any {
    let rel = 0;
    let res = 0;
    this.warehouse_move_data.ware_stock_detailed_id.forEach((_item: any, index: any) => {
      if (this.warehouse_move_data.check[index] == 1) {
        if (parseInt(this.warehouse_move_data.qty[index]) < parseInt(this.warehouse_move_data.move_qty[index])) {
          rel = 1;
        }
      }
      if (this.warehouse_move_data.check[index] == 0) {
        res = res + 1;
      }

    });
    const tot_check = this.warehouse_move_data.check.length;
    if (tot_check == res) {
      this.toastr.warning('Please select atleast on row');
      return false;
    }
    if (rel == 1) {
      this.toastr.warning('move quantity should be less than or equal to available quantity');
      return false;
    }
    if (this.warehouse_move_data.move_warehouse_id <= 0) {
      this.toastr.error('Please select warehouse');
      return false;
    }

    this.warehouse_move_data.user_id = this.user_data.user_id;
    this.loaderService.display(true);
    this.reportService.saveWarehouse_move_data(this.warehouse_move_data).subscribe((result: any) => {
      window.scrollTo(0, 0);
      if (result['status'] == 'Success') {
        this.loaderService.display(false);
        this.toastr.success(result.msg);
        this.modalRef?.close();
        this.warehouse_move_data.move_warehouse_id = 0;
        this.total_move_qty = 0;
        this.listWarehouseReport()
      } else {
        this.toastr.error(result.msg);
        this.loaderService.display(false);
      }
    });
  }

  public listWarehouseReport() {
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.search_text,
      medicine_id: this.medicine_id
    };
    this.loaderService.display(true);
    this.reportService.listWarehouseReport(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.stock_data = result['data'];
        this.warehouse_data = result['warehouse'];
        let total_amount = 0;
        for (const data of this.warehouse_data) {
          for (const data1 of data.WAREHOUSE) {
            total_amount = total_amount + parseInt(data1.WAREHOSE_AVAILABLE_QUANTITY);
          }
          data['total_amount'] = total_amount;
          total_amount = 0;
        }
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public listWarehousepurchaseReport(warehouse: any, item_id: any, warehouse_id: any) {
    this.medicine = warehouse.TRADE_NAME;
    this.warehouse_name = warehouse.WAREHOUSE_NAME;
    this.warehouse_move_data.medicine_id = item_id;
    const postData = {
      medicine_id: item_id,
      warehouse_id: warehouse_id,
    };
    this.loaderService.display(true);

    this.reportService.listWarehousepurchaseReport(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'Success') {
        this.purchase_data = result['data'];
        let i = 0;
        let total = 0;
        for (const data of this.purchase_data) {
          total = total + parseInt(data.WAREHOSE_AVAILABLE_QUANTITY);
          this.warehouse_move_data.ware_stock_detailed_id[i] = data.WAREHOUSE_STOCK_DETAIL_ID;
          this.warehouse_move_data.purchase_detailed_id[i] = data.PURCHASE_DETAILS_ID;
          this.warehouse_move_data.purchase_id[i] = data.PURCHASE_ID;
          this.warehouse_move_data.check[i] = 0;
          this.warehouse_move_data.qty[i] = data.WAREHOSE_AVAILABLE_QUANTITY;
          this.warehouse_move_data.move_qty[i] = 0;
          this.warehouse_move_data.old_warehouses_id[i] = data.WAREHOUSE_ID;
          data['check'] = 0;
          i = i + 1;
        }
        this.total_available_qty = total;
      }
    });
  }

  protected open(content: any) {
    this.modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
    this.modalRef.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  protected getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
